import { BigNumber } from 'ethers'
import { useChainCalls } from '../../../hooks'
import { Account, createCall, decodeResult } from './utils'

interface UserStake {
  startBlock: number
  claimedBlock: number
  lockedAmount: BigNumber
  withdrawn: boolean
}

interface StakingData {
  userStakes?: UserStake[]
  stopBlock?: number
  durationInBlocks?: number
}

export function useStaking(stakingAddress: string | undefined, account: Account | undefined): StakingData {
  const calls =
    account && stakingAddress
      ? [
          createCall(stakingAddress, 'stopBlock', []),
          createCall(stakingAddress, 'durationInBlocks', []),
          createCall(stakingAddress, 'getUserStakes', [account]),
        ]
      : []
  const results = useChainCalls(calls)

  return {
    stopBlock: results[0] && decodeResult('stopBlock', results[0]),
    durationInBlocks: results[1] && decodeResult('durationInBlocks', results[1]),
    userStakes: results[2] && decodeResult('getUserStakes', results[2]),
  }
}

export function useClaimableAmounts(
  stakesCount: number | undefined,
  stakingAddress: string | undefined,
  account: Account | undefined
) {
  const calls = []
  if (account && stakesCount && stakingAddress) {
    for (let i = 0; i < stakesCount; i++) {
      calls.push(createCall(stakingAddress, 'getClaimable', [account, i]))
    }
  }
  const results = useChainCalls(calls)
  return results.map((result) => (result ? (decodeResult('getClaimable', result) as BigNumber) : BigNumber.from(0)))
}
